import { entries } from "../entries";
import { limitSize } from "../limitSize";

/**
 * Create a string representation of the element
 */
export function describe(element: HTMLElement | string): string {
    if (!element) {
        return;
    }

    if (typeof element === "string") {
        return element;
    }

    try {
        return (
            [nodeType(element), contents(element)].filter(Boolean).join(" ") ||
            `${element}`
        );
    } catch (error) {
        // Fallback to simple string representation
        return `${element}`;
    }
}

/**
 * Get the node type name of the element
 */
const nodeType = (element: HTMLElement): string =>
    typeof element.nodeType === "number"
        ? entries(Node).find(
              ([, enumerator]) => enumerator === element.nodeType,
          )[0]
        : undefined;
/**
 * Create a string representation of the element's content
 */
function contents(element: HTMLElement): string {
    if (typeof element.nodeName !== "string") {
        return "";
    }

    if (element.nodeType === Node.TEXT_NODE) {
        return element.nodeValue;
    }

    return querySelector(element);
}

/**
 * The attribute value of in the CSS selector
 */
const equals = (value: string): string =>
    value ? `^="${limitSize(value)}"` : "";

/**
 * Create a string representation of the element's CSS selector
 */
function querySelector(element: HTMLElement): string {
    const parts = [element.nodeName.toLowerCase()];
    const attributes = [].map.call(
        element.attributes,
        ({ name, value }) => `[${name.toLowerCase()}${equals(value)}]`,
    );
    attributes.length && parts.push(attributes.join(""));
    return parts.join("");
}
